import React from 'react';
import { Redirect } from 'react-router-dom';

import { APICore } from '../helpers/api/apiCore';

const Root = () => {
    const api = new APICore();

    const getRootUrl = () => {
        let url: string = 'auth/login';

        // check if user logged in or not and return url accordingly
        // skynyx.dev (PHP) serves all public/marketing pages; this React app
        // is auth + dashboard only, so the root goes straight into the product.
        if (api.isUserAuthenticated() === false) {
            url = 'auth/login';
        } else {
            url = 'profile/overview';
        }
        return url;
    };

    const url = getRootUrl();

    return <Redirect to={`/${url}`} />;
};

export default Root;
